import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import classNames from 'classnames/bind';

import './Background.css';

class DGRBackground extends Component {

    render(){
        const { isBlurred, isExpanded} = this.props.DGRBackgroundStore;

        var heroClass = classNames({
            'hero': true,
            'blurred': isBlurred,
        });
        var darkenClass = classNames({
            'darken': true,
            'expanded': isExpanded,
        });
            return( 
                    <div className='bgImages'>
                        <div className={heroClass}></div>
                        <div className={darkenClass}></div>
                    </div>
            )
    }
}

DGRBackground = inject('DGRBackgroundStore')(observer(DGRBackground))     
export default DGRBackground



// WEBPACK FOOTER //
// ./src/components/DGR/Background/Background.js